export default {

    namespaced: true,

    state: {
        fnCallFlag: null,
    },

    getters: {

    },

    mutations: {
        setFnCallFlag(state, fnCallFlag) {
            state.fnCallFlag = fnCallFlag;
        },
    },

    actions: {

    },

}